import { LightboxesService } from './../components/lightboxes/lightboxes.service';
import { NotificacoesService } from './../../modules/notificacoes/services/notificacoes.service';
import { NotificacoesState } from './../states/notificacoes.state';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class NotificacoesFacade {
  
  
  constructor(
    private notificacoesState: NotificacoesState,
    private notificacoesService: NotificacoesService,
    private lightboxesService: LightboxesService,
    ) { }

  requestNotificacoes() {
    this.notificacoesState.setRequestingNotificacoes(true);

    this.notificacoesService.getNotificacoesQuantidade().subscribe(
      response => this.handleSuccessfulGetNotificacoes(response),
      error => this.handleFailureGetNotificacoes(error),
      () => this.notificacoesState.setRequestingNotificacoes(false),
    );
  }

  private handleSuccessfulGetNotificacoes(response: any) {
    this.notificacoesState.setNotificacoes(response);
  }

  private handleFailureGetNotificacoes(error: any) {
    this.lightboxesService.open({
      title: 'Atenção',
      text: '',
    });

  }

  requestNotificacoesIfUnset() {
    if(this.notificacoesState.isEmpty())
      this.requestNotificacoes();
  }

  getNotificacoes() {
    return this.notificacoesState.getNotificacoes();
  }
}